const breakpoints = {
    sm: 320,
    md: 672,
    lg: 1056,
    xl: 1312,
    mx: 1584,
    nav: 1270,
};

export const mediaMin = (breakpoint, screenWidth = window.innerWidth) =>
    breakpoints[breakpoint] && screenWidth >= breakpoints[breakpoint];
